import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const QuestionDBList = lazy(() => import('src/pages/questiondb/list'));
const QuestionDBNew = lazy(() => import('src/pages/questiondb/new'));
const QuestionDBEdit = lazy(() => import('src/pages/questiondb/edit'));
const QuestionDBReport = lazy(() => import('src/pages/questiondb/report'));
const QGenNew = lazy(() => import('src/pages/qgen/new'));
const QGenList = lazy(() => import('src/pages/qgen/list'));

const InquiryList = lazy(() => import('src/pages/inquiry/list'));

const UserDBList = lazy(() => import('src/pages/userdb/list'));
const UserDBEdit = lazy(() => import('src/pages/userdb/edit'));

const WorkbookNew = lazy(() => import('src/pages/workbook/new'));
const WorkbookList = lazy(() => import('src/pages/workbook/list'));

// ----------------------------------------------------------------------

const academy = {
  path: 'questiondb',
  children: [
    {
      path: 'list',
      element: <QuestionDBList />,
    },
    {
      path: 'new',
      element: <QuestionDBNew />,
    },
    {
      path: ':id/edit',
      element: <QuestionDBEdit />,
    },
    {
      path: 'report',
      element: <QuestionDBReport />,
    },
  ],
};

const inquiry = {
  path: 'inquiry',
  children: [
    {
      path: 'list',
      element: <InquiryList />,
    },
  ],
};

const qgen = {
  path: 'qgen',
  children: [
    {
      path: 'new',
      element: <QGenNew />,
    },
    {
      path: 'list',
      element: <QGenList />,
    },
  ],
};

const worksheet = {
  path: 'userdb',
  children: [
    {
      path: 'list',
      element: <UserDBList />,
    },
    {
      path: 'edit',
      element: <UserDBEdit />,
    },
  ],
};

const workbook = {
  path: 'workbook',
  children: [
    {
      path: 'new',
      element: <WorkbookNew />,
    },
    {
      path: 'list',
      element: <WorkbookList />,
    },
  ],
};

export const adminRoutes = [
  {
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [academy, worksheet, inquiry, qgen, workbook],
  },
];
